export enum dropdownFetchMode { Autofill = "autofill", Dropdown = "dropdown"}
export enum uploadMessageMode { Uploading = "1", Scanning = "2"}
export enum bucketAvScanningStatus { 
    Unscanned = "unscanned", 
    Infected = "infected", 
    Clean = "clean", 
    Scanning="scanning", 
    AssumedClean="assumed_clean_via_setting"
}

export enum bookingType {
    Air = "AIR",
    Sea = "SEA"
}

export enum BookingStatus {
    DRAFT = 'DRAFT',
    REQUEST_SUBMITTED = 'REQUEST_SUBMITTED',
    SHIPPED_TO_PHIL = 'SHIPPED_TO_PHIL',
    RECEIVED_AT_DECON = 'RECEIVED_AT_DECON',
    RELEASED_FROM_DECON = 'RELEASED_FROM_DECON',
    ONHOLD = 'ONHOLD',
    SHORTLANDED = 'SHORTLANDED',
    OVERLANDED = 'OVERLANDED',
    AIR_BOOKING_COMPLETE = 'AIR_BOOKING_COMPLETE',
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED'
  }
export enum BookingStatusIcons {
    ICON_SUCCESS = 'check-circle',
    ICON_ITEM = 'checkbox-blank-circle',
    ICON_WARNING = 'alert-circle-outline',
    ICON_CANCEL = 'stop-circle-outline'
}
export enum BookingStatusStyles {
    ICON_COLOR_SUCCESS = 'success-icon',
    ICON_COLOR_ITEM = 'item-icon item-span',
    ICON_COLOR_WARNING = 'warning-icon',
    ICON_COLOR_CANCEL = 'cancel-icon'
}
export enum TrailingStatusClassIndicator {
    INDICATOR_IDLE = "indicator",
    INDICATOR_DONE = "indicator indicator-done"
}
export enum TrailingStatusClassCircle {
    CIRCLE_IDLE = "circle",
    CIRCLE_DONE = "circle circle-done"
}

export enum ErrorEmailCodes {
    UNSUPPORTED_DATE_FORMAT = "UNSUPPORTED_DATE_FORMAT"
}